export default __webpack_public_path__ + "static/media/ALIGN_CENTER_unpressed.b3b18556.svg";